import { useAttendeeStatus } from 'amazon-chime-sdk-component-library-react'
import useRemoteParticipants from './useRemoteParticipants'

/**
 * Hook to detect if the remote participant is muted
 * Returns the mute state of the first remote participant
 * @returns Boolean indicating if the remote participant is muted
 */
export const useRemoteParticipantMuteState = (): boolean => {
  const { firstRemoteAttendee } = useRemoteParticipants()
  const attendeeId = firstRemoteAttendee?.chimeAttendeeId || ''
  const attendeeStatus = useAttendeeStatus(attendeeId)

  if (!attendeeId) {
    return false
  }

  return attendeeStatus.muted
}
